<i18n lang="json">
{
  "en": {
    "learnMore": "Learn about this manufacturer"
  },
  "fr": {
    "learnMore": "En savoir plus sur ce fabricant"
  }
}
</i18n>

<template>
  <div>
    <div class="flex items-center mb-4 gap-4 lg:mb-6">
      <div v-if="image && !isLargeScreen" class="flex-shrink-0 size-14 rounded-[50%] overflow-hidden bg-primary-50">
        <img :src="image" class="size-full object-scale-down p-2" :alt="imageAlt" />
      </div>
      <div class="typography-subtitle-2">{{ title }}</div>
    </div>

    <div class="flex gap-6 mb-4 items-center">
      <div v-if="image && isLargeScreen" class="flex-shrink-0 size-20 rounded-[50%] overflow-hidden bg-primary-50">
        <img :src="image" class="size-full object-scale-down p-4" :alt="imageAlt" />
      </div>
      <TrustedHtml :html="htmlContent" class="typography-caption" />
    </div>

    <NuxtLink
      v-if="slug"
      class="typography-link-1"
      @click.prevent="clickHandler"
      :to="getLocalePath(`/brand/${props.slug}`)"
      >{{ t('learnMore') }}</NuxtLink
    >
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  image?: string
  imageAlt?: string
  htmlContent: string
  slug?: string
}>()

const emit = defineEmits<{
  learnMoreClicked: [value: void]
}>()

const isLargeScreen = useIsLargeScreen()
const { t } = useI18n()

const clickHandler = async ({ currentTarget: target }: { currentTarget: HTMLAnchorElement }) => {
  await windowNavigateTo(target)

  emit('learnMoreClicked')
}
</script>
